import { render, staticRenderFns } from "./OpenCard.vue?vue&type=template&id=663c2bd8&scoped=true&"
import script from "./OpenCard.vue?vue&type=script&lang=js&"
export * from "./OpenCard.vue?vue&type=script&lang=js&"
import style0 from "./OpenCard.vue?vue&type=style&index=0&id=663c2bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663c2bd8",
  null
  
)

export default component.exports